module.exports = __webpack_public_path__ + "static/media/UPS_logo.da98fadb.svg";